import React from "react";
import RestoranNerede from "../assets/svg/RestoranNerede.png";
import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <div className="flex felx-1 w-full">
      <Link to={".."}>
        <img
          src={RestoranNerede}
          alt=""
          className={"h-14 bg-white mt-8 ml-5"}
        />
      </Link>
    </div>
  );
}
